import { BarChart } from "@mantine/charts";
import { useReportingStore } from "../../../../../stores/ReportingStore";
import { Group, Paper, Text } from "@mantine/core";
import LoaderStats from "../../LoaderStats";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useLeadsStore } from "../../../../../stores/LeadsStore";
import { useMemo } from "react";
import { getChartColors } from "../../../../../functions/utilFunctions";

const LeadsSummary = () => {
  const lang = useLanguage((s) => s.language);
  const actualStats = useReportingStore((s) => s.actualStatsDate);
  const dateRange = useReportingStore((s) => s.dateRange);
  const systemStatus = useLeadsStore((s) => s.systemStatuses);
  const customStatus = useLeadsStore((s) => s.customStatuses);

  const series = useMemo(() => {
    let allStatus = [...systemStatus, ...customStatus].map((item, index) => ({
      name: item.name,
      color: item.color ? `#${item.color}` : `${getChartColors()[index]}.5`,
    }));
    return allStatus;
  }, [customStatus, systemStatus]);

  const data = useMemo(() => {
    let customData = [];

    actualStats.forEach((item) => {
      let customStatusData = {};
      item.prm_contacts_status.forEach((x) => {
        let status = customStatus.find((y) => y.id === x.custom_status_id);

        if (status) customStatusData[status.name] = x.contacts_total;
      });
      customData.push({
        date: item.date,
        [lang.components.status_selector.statuses.opener]: item.opener,
        [lang.components.status_selector.statuses.clicker]: item.clicker,
        [lang.components.status_selector.statuses.answerer]: item.answerer,
        ...customStatusData,
      });
    });

    return customData;
  }, [
    actualStats,
    customStatus,
    lang.components.status_selector.statuses.answerer,
    lang.components.status_selector.statuses.clicker,
    lang.components.status_selector.statuses.opener,
  ]);

  return (
    <Paper pos={"relative"} w={"100%"} p={"xl"} pt={"md"}>
      <LoaderStats isDate />

      <Group mb={32} justify="center">
        <Text size="lg" fw={600}>
          {lang.reports.leads_summary}{" "}
          {!dateRange.end_date && !dateRange.start_date
            ? lang.reports.last_60_days
            : lang.reports.per_date}
        </Text>
      </Group>

      <BarChart
        h={300}
        w={"100%"}
        data={data}
        dataKey="date"
        type="stacked"
        series={series}
        tickLine="y"
        yAxisLabel="Contacts"
        xAxisLabel="Status"
      />

      {/* <Group gap={"xl"} justify="center" align="center" mt={16}>
        <Group>
          <ColorSwatch color={`var(--mantine-color-secondary-5)`} size={16} />
          <Text size="sm">{lang.reports.emails_sent}</Text>
        </Group>
        <Group>
          <ColorSwatch color={`var(--mantine-color-blue-5)`} size={16} />
          <Text size="sm">{lang.reports.linkedin_sent}</Text>
        </Group>
      </Group> */}
    </Paper>
  );
};

export default LeadsSummary;
